import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { ResBskRoutes } from './resbsk.routes';
import { ListResBskComponent } from './list-resbsk/list-resbsk.component';
import { FormResBskComponent } from './_components/form-resbsk/form-resbsk.component';
import { AddResBskComponent } from './add-resbsk/add-resbsk.component';
import { EditResBskComponent } from './edit-resbsk/edit-resbsk.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        ResBskRoutes,
        SharedDocumalisModule,
        TranslateModule,
        FormResBskComponent,
    ],
    declarations: [
        ListResBskComponent,
        AddResBskComponent,
        EditResBskComponent
    ]
})
export class ResBskModule { }
